const starterPalette = [
    '#0b81a2', '#59a89c', '#9d2c00', '#36b700',
    '#e25759', '#595959', '#f0c571', '#7e4794'
]

function hexToHsl(hexColor) {
  let r = 0,
    g = 0,
    b = 0;
  if (hexColor.length === 4) {
    r = "0x" + hexColor[1] + hexColor[1];
    g = "0x" + hexColor[2] + hexColor[2];
    b = "0x" + hexColor[3] + hexColor[3];
  } else if (hexColor.length === 7) {
    r = "0x" + hexColor[1] + hexColor[2];
    g = "0x" + hexColor[3] + hexColor[4];
    b = "0x" + hexColor[5] + hexColor[6];
  }
  // Then to HSL
  r /= 255;
  g /= 255;
  b /= 255;
  let cmin = Math.min(r, g, b),
    cmax = Math.max(r, g, b),
    delta = cmax - cmin,
    h = 0,
    s = 0,
    l = 0;

  if (delta === 0) h = 0;
  else if (cmax === r) h = ((g - b) / delta) % 6;
  else if (cmax === g) h = (b - r) / delta + 2;
  else h = (r - g) / delta + 4;

  h = Math.round(h * 60);

  if (h < 0) h += 360;

  l = (cmax + cmin) / 2;
  s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
  s = +(s * 100).toFixed(1);
  l = +(l * 100).toFixed(1);

  return [h, s, l]
}

function hslToHex(h, s, l) {
  l /= 100;
  const a = s * Math.min(l, 1 - l) / 100;
  const f = n => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color).toString(16).padStart(2, '0');   // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}

export const getPalette = function (count) {
    let palette = [];

    for (const color of starterPalette) {
        palette.push(color)
    }

    let i = 0;
    let previousHSLColor = null;
    while (palette.length < count) {
        let baseColor = palette[i];
        let baseHSLColor = hexToHsl(baseColor);
        let newHue = baseHSLColor[0] - Math.floor(Math.random() * 360);
        if (newHue < 0) { newHue += 360 }
        let newSat = baseHSLColor[1];
        let newLight = baseHSLColor[2];
        if (previousHSLColor) {
            const step = 20.0;
            newSat = previousHSLColor[1];
            newLight = previousHSLColor[2];
            if (previousHSLColor[1] > 50 && previousHSLColor[2] > 50) {
                // снижаем насыщенность и яркость
                newSat -= step
                newLight -= step
            }
            if (previousHSLColor[1] > 50 && previousHSLColor[2] < 50) {
                // снижаем насыщенность, повышаем яркость
                newSat -= step
                newLight += step
            }
            if (previousHSLColor[1] < 50 && previousHSLColor[2] < 50) {
                // повышаем насыщенность и яркость
                newSat += step
                newLight += step
            }
            if (previousHSLColor[1] < 50 && previousHSLColor[2] > 50) {
                // повышаем насыщенность, снижаем яркость
                newSat += step
                newLight -= step
            }
        }
        previousHSLColor = [newHue, newSat, newLight]
        let newColor = hslToHex(newHue, newSat, newLight);
        // console.log(newHue, newSat, newLight)
        // console.log(baseColor, newColor)
        palette.push(newColor)
        i++;
    }
    //
    // console.log(palette)
    return palette
}